import { ApolloError } from '@apollo/client';
import { GraphQLError } from 'graphql';
import { ErrorCode } from '../gen/graphql';
import { defaultErrorMessage, errorMessages } from '../const/ErrorMessage';

// APIエラー時に表示するメッセージ共通処理
// NOTE: 個別処理が必要な場合はどう実装するか要検討
export const getApiErrorMessage = (e: unknown, fallbackErrorMessage?: string): string => {
  if (!(e instanceof ApolloError)) {
    return fallbackErrorMessage ?? defaultErrorMessage;
  }

  const errorCodes = getGraphQLErrorCodes(e);

  for (const code of errorCodes) {
    const message = errorMessages.get(code);
    if (message) {
      return message;
    }
  }

  return fallbackErrorMessage ?? defaultErrorMessage;
};

/**
 * ApolloErrorからエラーコードを取り出す
 * @param ae ApolloError
 * @return エラーコードの配列
 */
export const getGraphQLErrorCodes = (ae: ApolloError): ErrorCode[] => {
  return ae.graphQLErrors
    .map((value: GraphQLError) => {
      return value.extensions.code;
    })
    .filter((errorCode): errorCode is ErrorCode => errorCode !== undefined);
};

export const isErrorCode = (code: unknown): code is ErrorCode => {
  return Object.values(ErrorCode).some((v) => v === code);
};
